export class TraineePreAssessmentReportCard {
  totalScorePercentage: number;
  slideReports: SlideReport[];
}

export class SlideReport {
  slideName: string;
  questionReports: QuestionReport[];
  scorePercentage: any;
}

export class QuestionReport {
  questionId: string;
  correctness: string;
  traineeResponses: TraineeResponse[]
}

export class TraineeResponse {
  key: Key;
  value: string;
}

export class Key {
  userId: string;
  name: string;
}
